module.exports = __webpack_public_path__ + "static/media/blogspindark.5c6df5db.svg";